import { useEffect, useState } from "react";
import { Steps } from "primereact/steps";
import ModelSelectionStep from "./components/ModelSelectionStep";
import DispatchDetailsStep from "./components/DispatchDetailsStep";
import AssignLocationsStep from "./components/AssignLocationsStep";
import PreviewStep from "./components/PreviewStep";
import { useNavigate } from "react-router-dom";
import CommenDialog from "./components/dialogbox";
import { toast } from "react-toastify";
import { toastOptObj } from "../../../utils/constants";
import { useParams } from "react-router-dom";
import "./css/send-for-tbs.css";
import { APIGetTBSDetails } from "../../../service/api-service";
import { GetTBSDetailsResEntity } from "../../../interface/tbs-tracker/send-tbs";
import Loader from "../../../components/loader";
const stepItems = [
    { label: "Add Model" },
    { label: "Dispatch Details" },
    { label: "Assign Locations" },
    { label: "Preview" },
];

const SentForTBSSteps = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [tbsData, setTbsData] = useState<GetTBSDetailsResEntity | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [stepperIndex, setStepperIndex] = useState<number>(0);
    const [tbsNumber, setTbsNumber] = useState<string>("");
    const [showSuccessDialog, setShowSuccessDialog] = useState<boolean>(false);
    const handleNextStep = () => {
        if (stepperIndex < stepItems.length - 1) {
            setStepperIndex((prev) => prev + 1);
        }
    };

    const handlePrevStep = () => {
        if (stepperIndex > 0) {
            setStepperIndex((prev) => prev - 1);
        }
    };

    const fetchTBSDetails = async () => {
        if (!id) return;

        setIsLoading(true);

        try {
            const resp = await APIGetTBSDetails(id);
            if (
                resp &&
                resp.data &&
                (resp.status === 200)
            ) {
                const apiResp = resp.data;

                if (apiResp && apiResp.statusCode === 200 && apiResp.data) {
                    setTbsData(apiResp.data);
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (!id) return;

        const savedStep = localStorage.getItem(`tbs-step-${id}`);

        if (savedStep !== null) {
            setStepperIndex(Number(savedStep));
        }
    }, [id]);

    useEffect(() => {
        if (!id) return;

        localStorage.setItem(`tbs-step-${id}`, stepperIndex.toString());
        fetchTBSDetails();
    }, [id, stepperIndex]);

    useEffect(() => {
        const element = document.getElementById("stepper-top");

        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, [stepperIndex]);

    if (!tbsData) {
        return <Loader isLoading={true} />;
    }
    return (
        <>
            <div className="content-wrapper">
                <div className="d-flex justify-content-end align-items-center gap-2 w-100 mb-3">
                    <div className="flex-1 w-100">
                        <div className="col-lg-4 col-md-4 col-12">
                            <h2 className="fw-bold mb-0">Sent for TBS</h2>
                        </div>
                    </div>
                </div>
                <div className="card card-rounded mb-4" id="stepper-top">
                    <div className="card-body">
                        <Steps
                            model={stepItems}
                            activeIndex={stepperIndex}
                            readOnly={false}
                            onSelect={(e) => {
                                const targetStep = e.index;
                                if (targetStep <= stepperIndex) {
                                    setStepperIndex(targetStep);
                                    return;
                                }
                                toast.error("Please click on Save & Next...", toastOptObj);
                            }}
                        />
                    </div>
                </div>
                <div className="mt-4">
                    {stepperIndex === 0 && (
                        <ModelSelectionStep
                            tbsId={id!}
                            modelData={tbsData.model}
                            onNext={handleNextStep}
                        />
                    )}
                    {stepperIndex === 1 && (
                        <DispatchDetailsStep
                            tbsId={id!}
                            dispatchData={tbsData.dispatch}
                            onBack={handlePrevStep}
                            onNext={handleNextStep}
                        />
                    )}
                    {stepperIndex === 2 && (
                        <AssignLocationsStep
                            locations={tbsData.locations}
                            qty={tbsData.model.qty}
                            materialHeight={tbsData.model.height}
                            typeOfTbs={tbsData.model.typeOfTbs}
                            onBack={handlePrevStep}
                            onNext={handleNextStep}
                        />
                    )}
                    {stepperIndex === 3 && (
                        <PreviewStep
                            previewData={tbsData}
                            onBack={handlePrevStep}
                            onSubmit={(tbsNo) => {
                                localStorage.removeItem(`tbs-step-${id}`);
                                setTbsNumber(tbsNo);
                                setShowSuccessDialog(true);
                            }}
                            isView={true}
                        />
                    )}
                </div>
                <CommenDialog
                    isOpen={showSuccessDialog}
                    title="TBS items sent Successfully!"
                    description={
                        <>
                            Tracker <strong>#{tbsNumber}</strong> has been sent at store.
                        </>
                    }
                    buttonText="Close"
                    onClose={() => {
                        localStorage.removeItem(`tbs-step-${id}`);
                        setShowSuccessDialog(false);
                        navigate("/TBS/send-for-tbs");
                    }}
                />
            </div>
        </>
    );
};

export default SentForTBSSteps;